import Model from '@/store/model';
import EventsUsersEventVariables from './events_users_event_variables';

class Notification extends Model {
  map(json) {
    super.map(json);

    if (json.events_users_event_variables !== null &&
        json.events_users_event_variables !== undefined) {
      this.mapArray(
        'eventsUsersEventVariables',
        json.events_users_event_variables,
        EventsUsersEventVariables,
      );
    }
  }
}
export default Notification;
